<div class="settings">
    <mat-slide-toggle color="primary" [checked]="widget.options_dict.my_tasks"
                      [(ngModel)]="widget.options_dict.my_tasks">
    <span class="settings-label">
      {{ 'WIDGETS.SETTINGS_LABELS.MY_TASKS' | translate }}
    </span>
    </mat-slide-toggle>
    <app-board-select-settings
            [widget]="widget"></app-board-select-settings>
</div>